import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { SharedModule } from '@app/shared/shared.module';
import { MaterialModule } from '@app/material.module';
import { AuthRoutingModule } from './auth-routing.module';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, SharedModule, FlexLayoutModule, AuthRoutingModule]
})
export class AuthModule {}
